(function(){
  const arrows = document.querySelector('.k9-arrows');
  if (!arrows) return;

  const prevBtn = arrows.querySelector('.k9-prev');
  const nextBtn = arrows.querySelector('.k9-next');
  
  // Get all thumbnail list items (not the buttons, the li elements with data-target)
  const getItems = () => Array.from(document.querySelectorAll('.thumbnail-list__item[data-target]'));
  
  const getActiveIndex = () => {
    const items = getItems();
    return items.findIndex(item => {
      const btn = item.querySelector('button');
      return btn && btn.getAttribute('aria-current') === 'true';
    });
  };

  const updateBtns = () => {
    const items = getItems();
    const idx = getActiveIndex();
    const total = items.length;
    
    if (total <= 1) {
      arrows.style.display = 'none';
      return;
    }
    arrows.style.display = 'block';
    prevBtn.disabled = idx <= 0;
    nextBtn.disabled = idx >= total - 1;
  };

  const go = (dir) => {
    const items = getItems();
    let idx = getActiveIndex();
    if (idx === -1) idx = 0;
    const nextIdx = idx + dir;
    
    if (nextIdx >= 0 && nextIdx < items.length) {
      const targetItem = items[nextIdx];
      const btn = targetItem.querySelector('button');
      if (btn) {
        // Simulate a real click
        btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        setTimeout(updateBtns, 150);
      }
    }
  };

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    go(-1);
  });
  
  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    go(1);
  });

  // Initial state
  setTimeout(updateBtns, 300);
  
  // Watch for changes
  const observer = new MutationObserver(() => setTimeout(updateBtns, 50));
  const thumbList = document.querySelector('.thumbnail-list');
  if (thumbList) observer.observe(thumbList, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
})();